import { createContext } from 'react';

import type { SplitListPanelContextValue } from '../provider/SplitListPanelProvider';

export const SplitListPanelStoreContext = createContext<SplitListPanelContextValue | null>(null);
